import React from "react";
import { Reveal } from "@/components/common/Reveal";

/**
 * Consistent section heading block: eyebrow + title + subtitle, centered by default.
 */
export const SectionHeading = ({ eyebrow, title, subtitle, align = "center", className = "" }) => {
  const isCenter = align === "center";
  return (
    <Reveal className={`${isCenter ? "text-center mx-auto max-w-3xl" : "max-w-3xl"} ${className}`}>
      {eyebrow && <span className="et-eyebrow mb-4">{eyebrow}</span>}
      <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-slate-900 mt-4">
        {title}
      </h2>
      {subtitle && (
        <p className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed">{subtitle}</p>
      )}
    </Reveal>
  );
};
